export default __webpack_public_path__ + "static/media/koii.df9b65b0.png";